import api from "./api";

// When a sign-in used a password from before the password rules, the server
// says so (`passwordUpgradeDue` in the login response, at every such sign-in).
// The request waits here, tied to that user, until the password has been
// changed in WeakPasswordModal — so another user signing in on this browser
// never sees it.
const KEY = "passwordUpgradeDueFor";

// The password that sign-in used, kept in memory only — never stored — so the
// modal right after sign-in needn't ask for it again. A reload forgets it, and
// the modal then asks: whoever has the browser by then must know it.
let signInPassword = null;

const markDue = (userId, password) => {
  localStorage.setItem(KEY, String(userId));
  signInPassword = password ?? null;
};
const isDue = (userId) => userId != null && localStorage.getItem(KEY) === String(userId);
const getSignInPassword = () => signInPassword;
const clear = () => {
  localStorage.removeItem(KEY);
  signInPassword = null;
};

// Signed-in change: this session stays, the user's other sessions end.
const changePassword = (currentPassword, newPassword) =>
  api.post("/api/user/change-password", { currentPassword, newPassword });

const PasswordUpgradeService = { markDue, isDue, getSignInPassword, clear, changePassword };

export default PasswordUpgradeService;
